export const authPaths = {
  base: 'auth',
  logIn: 'login',
  logout: 'logout',
};

export const authRoutes = {
  logout: `/${authPaths.base}/${authPaths.logout}`,
  logIn: `/${authPaths.base}/${authPaths.logIn}`,
};
